import { useState, useEffect } from 'react';
import { apiCall } from '../special/apiCall';
import { useAuthContext } from '../special/oAuthProvider';
import { useLocale } from '../special/LanguageProvider';

const BUSINESS_URL = process.env.REACT_APP_BUSINESS_WEB_URL ? process.env.REACT_APP_BUSINESS_WEB_URL.replace(/\/$/, '') : '';
const SHARED_URL = process.env.REACT_APP_SHARED_API_URL ? process.env.REACT_APP_SHARED_API_URL.replace(/\/$/, '') : '';

export default () => {
  const { isAuthenticated } = useAuthContext();
  const [products, setProducts] = useState([]);
  const { t } = useLocale();

  useEffect(
    () => {
      if (isAuthenticated) {
        const url = `${SHARED_URL}/navigation/urlsforuser?businessWebBaseUrl=${BUSINESS_URL}`;
        apiCall(url).then(data => {   
          let withText = [];
          if (!data.error) {    
            withText = data.map(entry => {
             // console.log("Entry", entry);
              let label = t(entry.displayText); //t(`Navigator.DisplayText.${entry.id}`) || entry.displayText;
              return {
                ...entry,
                label
              };
            });
          }
          setProducts(withText);
        });
      }
    },
    [isAuthenticated]
  );

  return products;
};
